import { Logger } from "../utils/Logger";
import { setAuthToken } from "../redux/actions";

// Deliberately does NOT dispatch clearAuthToken() before setAuthToken() —
// it used to, but that briefly set auth.authToken to "" between the two
// dispatches. AppMenu.tsx watches auth.authToken and treats any empty value
// as "logged out," immediately firing a real /api/auth/logout call plus a
// hard `window.location.href` redirect — which, if it lands mid-render,
// aborts React's in-progress commit and throws a `removeChild` DOM error
// (the browser tears down the document out from under React). Reproduced
// reliably by Hotel Booking v2's long status-polling loop, whose eventual
// "ok" response was often the first to carry a refreshed token after
// enough elapsed time — but setNewAuthToken() is called from every API
// function in the app, so the underlying race applied everywhere, not just
// there. setAuthToken()'s reducer already overwrites authToken
// unconditionally, so clearing first was never actually necessary.
export const setNewAuthToken = async (dispatch: any, token?: string) => {
  if (token) {
    Logger.info("Authorization Set: ", token);
    dispatch(setAuthToken(token));
  }
};
